import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { isEmpty } from "lodash-es";
import { useIntl } from "react-intl";
import { useParams } from "react-router-dom";
import { useApi } from "../../shared/api/index";
import { useNotification } from "~hooks/useNotification";

export const useFetchVenue = () => {
  const { fetchData } = useApi();
  const { organizationId, sport, dataId } = useParams();

  return useQuery({
    queryKey: ["venues", organizationId, dataId],
    queryFn: async () => {
      const result = await fetchData({
        url: `${sport}/o/${organizationId}/venues/${dataId}`,
      });
      return result?.data?.[0];
    },
    enabled: !!dataId,
  });
};

export const useFetchVenueById = (id) => {
  const { fetchData } = useApi();
  const { organizationId, sport } = useParams();

  return useQuery({
    queryKey: ["venues", organizationId, id],
    queryFn: async () => {
      const result = await fetchData({
        url: `${sport}/o/${organizationId}/venues/${id}`,
      });
      return result?.data?.[0];
    },
    enabled: false,
  });
};
const defaultParams = { sortBy: "nameLocal" }

export const useFetchVenues = (params = {}, enabled) => {
  const { fetchData } = useApi();
  const { organizationId, sport } = useParams();
  let URL = `${sport}/o/${organizationId}/venues`;
  if (!isEmpty(params)) {
    URL += `?${new URLSearchParams(params)?.toString()}`;
  }

  return useQuery({
    queryKey: ["venues", organizationId, JSON.stringify(params)],
    queryFn: async () => {
      const result = await fetchData({
        url: URL,
      });
      return result?.data || [];
    },
    enabled: !!enabled,
  });
};

export const useCreateVenue = () => {
  const { sport, organizationId } = useParams();
  const queryClient = useQueryClient();
  const { mutateData } = useApi();
  const { formatMessage } = useIntl();
  const notification = useNotification();

  return useMutation({
    mutationFn: async (data) => {
      return await mutateData({
        url: `${sport}/o/${organizationId}/venues`,
        method: "POST",
        data,
      });
    },
    onSuccess: () => {
      notification.success({
        message: formatMessage({
          id: "venue.create.success",
          defaultMessage: "Venue created successfully",
        }),
        placement: "bottomRight",
      });
      queryClient.invalidateQueries({ queryKey: ["venues"] });
    },
  });
};

export const useUpdateVenue = () => {
  const { sport, organizationId, dataId } = useParams();
  const queryClient = useQueryClient();
  const { mutateData } = useApi();
  const { formatMessage } = useIntl();
  const notification = useNotification();

  return useMutation({
    mutationFn: async (data) => {
      await mutateData({
        url: `${sport}/o/${organizationId}/venues/${dataId}`,
        method: "PUT",
        data,
      });
    },
    onSuccess: () => {
      notification.success({
        message: formatMessage({
          id: "venue.update.success",
          defaultMessage: "Venue updated successfully",
        }),
        placement: "bottomRight",
      });
      queryClient.invalidateQueries({ queryKey: ["venues"] });
    },
  });
};
